import { useRef, useState } from 'react'
import isNil from 'lodash-es/isNil'

import {
  EVENT_NAME_POINTER_CANCEL,
  EVENT_NAME_POINTER_UP,
} from '../../../../constants/event'
import { useEventListener } from '../../../../hooks'

// The pointer may leave the grid mid-drag, so the selection ends on the document's pointerup
export function useCalendarGridPointerSelection({ onPointerUp }) {
  const [selection, setSelection] = useState(null)

  // A pointerup right after a move comes before the move is rendered, so the latest selection lives here
  const selectionRef = useRef(null)

  function clearSelection() {
    selectionRef.current = null

    setSelection(null)
  }

  function updateSelection(getNextSelection) {
    selectionRef.current = getNextSelection(selectionRef.current)

    setSelection(selectionRef.current)
  }

  function handlePointerUp() {
    const lastSelection = selectionRef.current

    clearSelection()

    if (!isNil(lastSelection)) {
      onPointerUp(lastSelection)
    }
  }

  useEventListener({
    eventName: EVENT_NAME_POINTER_UP,
    handler: handlePointerUp,
  })

  useEventListener({
    eventName: EVENT_NAME_POINTER_CANCEL,
    handler: clearSelection,
  })

  return { selection, updateSelection }
}
